/**
 * Appearance: Light | Dark.
 *
 * Pure logic only — no React, no storage. This module decides *what* the
 * appearance should be; applying and persisting it happens elsewhere, so both
 * are testable in isolation.
 */

export const APPEARANCE_MODES = ['light', 'dark'] as const;
export type AppearanceMode = (typeof APPEARANCE_MODES)[number];

/** What the interface actually renders as. Same shape as `AppearanceMode` —
 *  kept as its own alias because the two mean different things (a user's
 *  choice vs. what's actually on screen), even though every mode is already
 *  concrete now that `system` is gone. */
export type ResolvedAppearance = 'light' | 'dark';

export const DEFAULT_APPEARANCE: AppearanceMode = 'light';

export function isAppearanceMode(value: unknown): value is AppearanceMode {
  return typeof value === 'string' && (APPEARANCE_MODES as readonly string[]).includes(value);
}

export const APPEARANCE_LABELS: Record<AppearanceMode, string> = {
  light: 'Light',
  dark: 'Dark',
};

/** Browser-chrome colour, so the status bar matches the app. */
export const THEME_COLOURS: Record<ResolvedAppearance, string> = {
  light: '#f4f6f8',
  dark: '#0b0c0e',
};
